import { useState, useEffect } from "react";

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  useEffect(() => {
    const setOnline  = () => setIsOnline(true);
    const setOffline = () => setIsOnline(false);
    window.addEventListener("online",  setOnline);
    window.addEventListener("offline", setOffline);
    return () => {
      window.removeEventListener("online",  setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);
  return isOnline;
}

/** Slim sticky top bar — only renders when offline, never blocks navigation */
export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      const t = setTimeout(() => setShow(true), 500);
      return () => clearTimeout(t);
    } else {
      setShow(false);
    }
  }, [isOnline]);

  if (!show) return null;

  return (
    <div style={{
      position:     "fixed",
      top:          0,
      left:         0,
      right:        0,
      zIndex:       9999,
      display:      "flex",
      alignItems:   "center",
      justifyContent: "center",
      gap:          6,
      background:   "rgba(120,53,15,0.95)",
      borderBottom: "1px solid rgba(234,179,8,0.2)",
      padding:      "3px 16px",
      color:        "#fde68a",
      fontSize:     11,
      fontFamily:   "DM Sans, sans-serif",
      fontWeight:   600,
      letterSpacing:"0.02em",
      pointerEvents:"none",
    }}>
      <span style={{
        width:        6,
        height:       6,
        borderRadius: "50%",
        background:   "#ef4444",
        flexShrink:   0,
      }} />
      Offline — changes cannot be saved until your connection is restored
    </div>
  );
}
